export default "__VITE_ASSET__uOIfxvE6__"